// import { IsTest } from "./tools";

export const account_type = '1';
// 港澳台
export const isHtm = process.env.plat === 'htm';
export const game_id = isHtm ? "29157" : "29080";
export const hostINTL = isHtm ? 'https://sg.intlgame.com' : 'https://aws-na.intlgame.com';
export const hostThird = isHtm ? 'https://sg-webproxy.intlgame.com' : 'https://aws-na-webproxy.intlgame.com';
// TODO 确定fb_app_id
export const fb_app_id = "1018333755673056";
export const ACCOUNT_PLAT_TYPE = 131;
export const ENV = 'prod' as any;
// export const INTL_ENV = IsTest ? 'test' : 'li-sg';
export const INTL_ENV = 'li-sg';
//TODO
export const ACCOUNT_APP_ID = isHtm ? "153011f55ca99902901dbea68fc00cb0" :'09af79d65d6e4fdf2d2569f0d365739d';
export const ACCOUNT_WEB_KEY = '4409a05c8ead0bb44aa83cb696652e81';

export const INTL_HOST = 'https://li-sg.intlgame.com';
// export const INTL_HOST = IsTest ? 'https://test-web-pass.intlgame.com' : 'https://li-sg.intlgame.com';

export const Langs = ['ja', 'ko', 'en', 'zh', 'th'] as const;
export type LangType = typeof Langs[number];

export const NormalRegesterUrl = 'https://nikke.onelink.me/cCNP/nwwol3hl';
export const HtmRegesterUrl = 'https://bit.ly/3Jz6XVo';
export const REGISTER_URL =  isHtm ? HtmRegesterUrl : NormalRegesterUrl;
const NomarlPresentMap =  ["Wand-20230719111333-P2cfabaacd529", "Wand-20230719111357-P3bd3dc475359", "Wand-20230719111427-P9a102a5d5d76"];
const HtmPresentMap = ["Wand-20230719111553-Pa6bc50515d4d", "Wand-20230719111609-P8abb1fd34ac8", "Wand-20230719111619-Pcf3b95ce7736"];
// 奖励 对应的编号
export const presentMap = isHtm ? HtmPresentMap : NomarlPresentMap;

export const TestServerMap = [
  { name: 'TX-TEST-KR1', id: 1 },
  { name: 'TX-TEST-US', id: 3},
  { name: 'TX-PRE-KR', id: 2 },
  { name: 'TX-AUDIT', id: 5 },
  { name: 'TX-TEST-KR2', id: 6 },
  { name: 'TX-EXP-KR', id: 7 },
];

export const NormalProdServerMap = [
  { name: 'JP', id: 81 },
  { name: 'NA', id: 82 },
  { name: 'KR', id: 83 },
  { name: 'Global', id: 84 },
  { name: 'SEA', id: 85 },
];

export const HTMProdServerMap = [
  { name: 'HMT', id: 91 },
];

export const ProdServerMap = isHtm ? HTMProdServerMap : NormalProdServerMap;

export const channel_map = {
  google: 6,
  facebook: 4,
  apple: 15,
  line: 14,
  twitter: 9,
  email: 131,
};

export enum MissionStatus {
  Unfinish = 0,
  Unrecive = 1,
  Recived = 2,
}

export enum RoleCardStatus {
  NotAvailable = 0,
  CanSign = 1,
  Signed = 2,
}


export const htmUrl = 'https://nikke.hotcool.tw/events/nikkebunny2024/';
